import { lazy } from 'react';

const Privacy = lazy(() => import('./Privacy'));
const PrivacyDiamondSeminar = lazy(() => import('./PrivacyDiamondSeminar'));

export const DIAMOND_EVENT_IDX = Number(process.env.REACT_APP_DIAMOND_EVENT_IDX);


/**
 * eventIdx → Privacy 컴포넌트 매핑
 * 새 행사 추가 시 여기에 매핑만 추가하면 됨
 */
const privacyMap = {
    [DIAMOND_EVENT_IDX]: PrivacyDiamondSeminar, // 2026 다이아몬드 세미나
};

/**
 * eventIdx에 해당하는 Privacy 컴포넌트를 반환
 * 매핑이 없으면 기본 Privacy 컴포넌트 반환
 * @param {number|string|null} eventIdx
 * @returns {React.LazyExoticComponent}
 */
export const getPrivacyComponent = (eventIdx) => {
    if (eventIdx && privacyMap[eventIdx]) {
        return privacyMap[eventIdx];
    }
    return Privacy;
};

export const FLIGHT_ACTIVITY_IDS = DIAMOND_EVENT_IDX === 12 
    ? [
        // 운영 (Production)
        110, 111, 112, 113, 114, 115, 121, 122,
        124, 125, 126, 127, 128, 129, 135, 136,
        166, 167, 168, 169, 170, 171, 177, 178
    ] 
    : [
        // 개발 (Development)
        57, 58, 59, 60, 61, 62, 63,
        70, 71, 72, 73, 74, 75, 81
    ];
